












































import { debounce } from 'lodash-es';
import { ref, defineComponent, computed } from '@vue/composition-api';

const name = 'ttam-catalog-carousel-preview-cta';
export default defineComponent({
  name,
  components: {},
  props: {
    productList: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const index = ref(0);
    const viSelect = ref();
    const viPopover = ref();
    const previewCtaDropdown = ref();
    const showing = ref(false);
    const emitQuery = debounce(val => {
      emit('search', val);
    }, 200);
    const refreshRef = ref();
    const menuRef = ref();
    const previewCtaVIDropdown = ref();

    const filterMethod = val => {
      if (showing.value) {
        emitQuery(val);
      }
    };

    const handleClick = () => {
      previewCtaDropdown?.value?.childNodes[0]?.childNodes[0]?.click?.();
    };
    const onRefresh = () => {
      emit('on-refresh');
    };
    const dropdownWidth = computed(() => previewCtaDropdown?.value?.clientWidth - 11 - 30 || 0);
    const handleSKUClick = item => {
      emit('selected-sku', item);
    };
    const handleVisible = visible => {
      showing.value = visible;
    };
    return {
      handleVisible,
      viSelect,
      viPopover,
      index,
      handleSKUClick,
      previewCtaVIDropdown,
      menuRef,
      refreshRef,
      filterMethod,
      dropdownWidth,
      handleClick,
      onRefresh,
      previewCtaDropdown,
    };
  },
});
